export const isRoleNameValid = (roleName: string) => roleName.trim().length >= 2 && roleName.length <= 200;
